"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = require("immutable");

var _netlifyCmsUiDefault = require("netlify-cms-ui-default");

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

const StyledImage = (
/*#__PURE__*/
0, _styledBase.default)((_ref) => {
  let {
    value: src
  } = _ref;
  return (0, _core.jsx)("img", {
    src: src || '',
    role: "presentation"
  });
}, {
  target: "e1ksx8c40",
  label: "StyledImage"
})(process.env.NODE_ENV === "production" ? {
  name: "6b4u1g",
  styles: "display:block;max-width:100%;height:auto;"
} : {
  name: "6b4u1g",
  styles: "display:block;max-width:100%;height:auto;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JbWFnZVByZXZpZXcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTTJGIiwiZmlsZSI6Ii4uLy4uL3NyYy9JbWFnZVByZXZpZXcuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IExpc3QgfSBmcm9tICdpbW11dGFibGUnO1xuaW1wb3J0IHsgV2lkZ2V0UHJldmlld0NvbnRhaW5lciwgQXNzZXQgfSBmcm9tICduZXRsaWZ5LWNtcy11aS1kZWZhdWx0JztcblxuY29uc3QgU3R5bGVkSW1hZ2UgPSBzdHlsZWQoKHsgdmFsdWU6IHNyYyB9KSA9PiA8aW1nIHNyYz17c3JjIHx8ICcnfSByb2xlPVwicHJlc2VudGF0aW9uXCIgLz4pYFxuICBkaXNwbGF5OiBibG9jaztcbiAgbWF4LXdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IGF1dG87XG5gO1xuXG5jb25zdCBTdHlsZWRJbWFnZUFzc2V0ID0gKHsgZ2V0QXNzZXQsIHZhbHVlIH0pID0+IHtcbiAgcmV0dXJuIDxBc3NldCBwYXRoPXt2YWx1ZX0gZ2V0QXNzZXQ9e2dldEFzc2V0fSBjb21wb25lbnQ9e1N0eWxlZEltYWdlfSAvPjtcbn07XG5cbmNvbnN0IEltYWdlUHJldmlld0NvbnRlbnQgPSBwcm9wcyA9PiB7XG4gIGNvbnN0IHsgdmFsdWUsIGdldEFzc2V0IH0gPSBwcm9wcztcbiAgaWYgKEFycmF5LmlzQXJyYXkodmFsdWUpIHx8IExpc3QuaXNMaXN0KHZhbHVlKSkge1xuICAgIHJldHVybiB2YWx1ZS5tYXAodmFsID0+IDxTdHlsZWRJbWFnZUFzc2V0IGtleT17dmFsfSB2YWx1ZT17dmFsfSBnZXRBc3NldD17Z2V0QXNzZXR9IC8+KTtcbiAgfVxuICByZXR1cm4gPFN0eWxlZEltYWdlQXNzZXQgey4uLnByb3BzfSAvPjtcbn07XG5cbmNvbnN0IEltYWdlUHJldmlldyA9IHByb3BzID0+IHtcbiAgcmV0dXJuIChcbiAgICA8V2lkZ2V0UHJldmlld0NvbnRhaW5lcj5cbiAgICAgIHtwcm9wcy52YWx1ZSA/IDxJbWFnZVByZXZpZXdDb250ZW50IHsuLi5wcm9wc30gLz4gOiBudWxsfVxuICAgIDwvV2lkZ2V0UHJldmlld0NvbnRhaW5lcj5cbiAgKTtcbn07XG5cbkltYWdlUHJldmlldy5wcm9wVHlwZXMgPSB7XG4gIGdldEFzc2V0OiBQcm9wVHlwZXMuZnVuYy5pc1JlcXVpcmVkLFxuICB2YWx1ZTogUHJvcFR5cGVzLm5vZGUsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBJbWFnZVByZXZpZXc7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

const StyledImageAsset = (_ref2) => {
  let {
    getAsset,
    value
  } = _ref2;
  return (0, _core.jsx)(_netlifyCmsUiDefault.Asset, {
    path: value,
    getAsset: getAsset,
    component: StyledImage
  });
};

const ImagePreviewContent = props => {
  const {
    value,
    getAsset
  } = props;

  if (Array.isArray(value) || _immutable.List.isList(value)) {
    return value.map(val => (0, _core.jsx)(StyledImageAsset, {
      key: val,
      value: val,
      getAsset: getAsset
    }));
  }

  return (0, _core.jsx)(StyledImageAsset, props);
};

const ImagePreview = props => {
  return (0, _core.jsx)(_netlifyCmsUiDefault.WidgetPreviewContainer, null, props.value ? (0, _core.jsx)(ImagePreviewContent, props) : null);
};

ImagePreview.propTypes = {
  getAsset: _propTypes.default.func.isRequired,
  value: _propTypes.default.node
};
var _default = ImagePreview;
exports.default = _default;